import React from "react";
import { AcessoSituacao } from "../../../../interfaces/acessos";
import { CHIP_ATENCAO, CHIP_NEUTRO, CHIP_PERIGO, CHIP_VERDE } from "../../paineis-admin/components/shared";

const SELOS: Record<AcessoSituacao, { rotulo: string; classe: string }> = {
  Ativo: { rotulo: "Ativo", classe: CHIP_VERDE },
  ConvitePendente: { rotulo: "Convite pendente", classe: CHIP_ATENCAO },
  ConviteExpirado: { rotulo: "Convite expirado", classe: CHIP_PERIGO },
  Desativado: { rotulo: "Desativado", classe: CHIP_NEUTRO },
};

export const rotuloSituacao = (s: AcessoSituacao): string => SELOS[s]?.rotulo ?? s;

export const SeloSituacao: React.FC<{ situacao: AcessoSituacao }> = ({ situacao }) => (
  <span className={SELOS[situacao]?.classe ?? CHIP_NEUTRO}>{rotuloSituacao(situacao)}</span>
);
